import React, { useEffect, useState, useRef, Component } from 'react';
import { ChevronDown } from 'lucide-react';
export const TableRowMenu = ({
  trigger,
  children
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const toggleMenu = e => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };
  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = event => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);
  // Handle escape key press
  useEffect(() => {
    const handleEscKey = event => {
      if (event.key === 'Escape') {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscKey);
    }
    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [isOpen]);
  return <div className="relative" ref={menuRef} data-id="element-1567">
      <div onClick={toggleMenu} className="cursor-pointer" data-id="element-1568">
        {trigger}
      </div>
      {isOpen && <div className="absolute z-50 min-w-[180px] bg-white border border-gray-200 rounded-md shadow-md py-1 right-0 top-full mt-1" data-id="element-1569">
          {children}
        </div>}
    </div>;
};
// Menu Item Component
TableRowMenu.Item = ({
  label,
  icon,
  onClick,
  disabled = false
}) => {
  return <button className={`w-full text-left px-4 py-2 flex items-center text-sm ${disabled ? 'text-gray-400 cursor-not-allowed' : 'text-gray-700 hover:bg-gray-50'}`} onClick={disabled ? undefined : onClick} disabled={disabled} data-id="element-1570">
      {icon && <span className="mr-2 text-gray-500" data-id="element-1571">{icon}</span>}
      {label}
    </button>;
};
// Menu Divider Component
TableRowMenu.Divider = () => {
  return <div className="h-px bg-gray-200 my-1" data-id="element-1572"></div>;
};
export default TableRowMenu;